/** Maps sign-in errors to user-facing messages (wrong password, etc.). */
export function formatLoginError(error: unknown): string {
  const message =
    error instanceof Error ? error.message : 'Invalid email or password.';
  const lower = message.toLowerCase();
  if (
    lower.includes('password') ||
    lower.includes('email') ||
    lower.includes('credential')
  ) {
    return message;
  }
  return 'Invalid email or password.';
}
